import {
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import {
  ErrorOutline as ErrorOutlineIcon,
  ContentCopy as ContentCopyIcon,
  OpenInNew as OpenInNewIcon,
} from "@mui/icons-material";
import { useState } from "react";
import useFetch from "hooks/useFetch";
import Copiable from "components/ui/Copiable";

export default function FailureDetailsMenuItem({ run, onClick }) {
  const [open, setOpen] = useState(false);
  const onToggle = () => {
    setOpen(!open);
  };

  const { data, isLoading, error } = useFetch(
    `/simulation/${run.id}/failure`,
    {},
    open
  );

  const errorText = data?.error_message || null;
  const failedRuns = data?.failed_run_indexes || [];

  return (
    <>
      <MenuItem
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
          onClick();
        }}
      >
        <ErrorOutlineIcon sx={{ mr: 1 }} fontSize="small" />
        Failure Details
      </MenuItem>
      {/* The dialog sits inside the Menu's React tree, and the Menu cancels
          Tab and arrow keys that reach it. */}
      <Dialog
        open={open}
        onClose={onToggle}
        onKeyDown={(e) => e.stopPropagation()}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Failure Details</DialogTitle>
        <DialogContent
          sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}
        >
          {isLoading && (
            <Typography variant="body2" color="textSecondary">
              Loading...
            </Typography>
          )}
          {error && (
            <Typography variant="body2" color="error">
              Could not load failure details.
            </Typography>
          )}
          {data && (
            <>
              <Typography variant="body2">
                <strong>Step:</strong> {data.step || "unknown"}
              </Typography>
              {data.failed_reason && (
                <Typography variant="body2">
                  <strong>Workflow reason:</strong> {data.failed_reason}
                </Typography>
              )}
              {failedRuns.length > 0 && (
                <Typography variant="body2">
                  <strong>Failed iterations:</strong> {failedRuns.join(", ")}
                </Typography>
              )}
              {errorText ? (
                <Box
                  component="pre"
                  sx={{
                    margin: 0,
                    padding: 1.5,
                    maxHeight: "50vh",
                    overflow: "auto",
                    whiteSpace: "pre-wrap",
                    overflowWrap: "anywhere",
                    fontFamily: "monospace",
                    fontSize: "12px",
                    backgroundColor: "grey.100",
                    borderRadius: 1,
                  }}
                >
                  {errorText}
                </Box>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No error details were recorded for this run.
                </Typography>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          {errorText && (
            <Copiable text={errorText}>
              <Button startIcon={<ContentCopyIcon />}>Copy</Button>
            </Copiable>
          )}
          {data?.logs_url && (
            <Button
              href={data.logs_url}
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<OpenInNewIcon />}
            >
              Open in Cloud Logging
            </Button>
          )}
          <Button onClick={onToggle} sx={{ fontWeight: "bold" }}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
